import { render, staticRenderFns } from "./bbgl-qc.vue?vue&type=template&id=0cc1f2ea&scoped=true"
import script from "./bbgl-qc.vue?vue&type=script&lang=js"
export * from "./bbgl-qc.vue?vue&type=script&lang=js"
import style0 from "./bbgl-qc.vue?vue&type=style&index=0&id=0cc1f2ea&prod&lang=scss"
import style1 from "./bbgl-qc.vue?vue&type=style&index=1&id=0cc1f2ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1f2ea",
  null
  
)

export default component.exports